import { lazy } from "react";
import { Route, Routes } from "react-router";
import { authPaths } from "../navigation/routes";
const SignInPage = lazy(() => import("./pages/SignInPage"));
const SignUpPage = lazy(() => import("./pages/SignUpPage"));
const GuestPage = lazy(() => import("./pages/GuestPage"));
const VerifyEmailPage = lazy(() => import("./pages/VerifyEmailPage"));
const ForgotPasswordPage = lazy(() => import("./pages/ForgotPasswordPage"));
const ResetPasswordPage = lazy(() => import("./pages/ResetPasswordPage"));
const ResetSentPage = lazy(() => import("./pages/ResetSentPage"));
const ResetInvalidPage = lazy(() => import("./pages/ResetInvalidPage"));
const ResetSuccessPage = lazy(() => import("./pages/ResetSuccessPage"));

export const authRouteEntries = [
  { path: authPaths["sign-in"], element: <SignInPage /> },
  { path: authPaths["sign-up"], element: <SignUpPage /> },
  { path: authPaths.guest, element: <GuestPage /> },
  { path: authPaths["sign-up-verification"], element: <VerifyEmailPage /> },
  { path: authPaths["forgot-email"], element: <ForgotPasswordPage /> },
  { path: authPaths["forgot-password"], element: <ResetPasswordPage /> },
  { path: authPaths["forgot-sent"], element: <ResetSentPage /> },
  { path: authPaths["reset-invalid"], element: <ResetInvalidPage /> },
  { path: authPaths["reset-success"], element: <ResetSuccessPage /> },
];

// The same route mapping is used by isolated browser stories and form integration tests.
export function AuthRoutes() {
  return (
    <Routes>
      {authRouteEntries.map((route) => (
        <Route key={route.path} {...route} />
      ))}
    </Routes>
  );
}
